import { StepFormWrapper } from '@client/components/common/StepFormWrapper';
import { getFirstPageUrl } from '../utils';
import type { StepFormWrapperProps } from '@client/components/common/StepFormWrapper/interfaces';

export const SignupWrapper: React.FC<StepFormWrapperProps> = (props) => (
  <StepFormWrapper
    backButtonUrl={getFirstPageUrl()}
    {...props}
  />
);
